<template>
<div class="simple-page">
  <HeadNav selectedLanguage="en" page="about" />

  <main class="simple-page__main">
    <h1>About Us</h1>

    <section>
      <h2>About Secure VPN</h2>
      <p>
        Secure VPN is committed to helping users enjoy a safer and more private internet experience. We provide information, guides, and resources about VPN technology, online privacy, and secure connections.
      </p>
      <p>
        As online privacy becomes increasingly important, VPN services help users protect their internet connections, especially when using public Wi-Fi networks, accessing online services, or browsing from different locations.
      </p>
      <p>
        Our website covers VPN features, connection methods, privacy protection, supported devices, and common questions about using VPN applications. We aim to make VPN technology simple and understandable for everyday users.
      </p>
      <p>
        Whether you want to improve your online privacy, secure your connection, or learn more about how VPNs work, Secure VPN provides practical information to help you make better decisions.
      </p>
    </section>

    <section>
      <h2>Our Mission</h2>
      <p>
        Our mission is to make online privacy and security easier to understand and more accessible. We believe users should have clear information about privacy tools and the technologies that help protect their digital experience.
      </p>
    </section>

    <section>
      <h2>What We Provide</h2>
      <p>Secure VPN provides:</p>
      <ul>
        <li>VPN guides and tutorials</li>
        <li>VPN feature explanations</li>
        <li>Download and installation information</li>
        <li>Privacy and security tips</li>
        <li>Answers to common VPN questions</li>
      </ul>
      <p>
        We continuously update our content to provide useful, accurate, and easy-to-understand VPN resources.
      </p>
    </section>
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'AboutUs',
  components: {
    HeadNav,
  },
  mounted() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('vpn-site');
    }
  },
};
</script>

<style lang="scss" scoped>
.simple-page {
  min-height: 70vh;
  background: #fff;
}

.simple-page__main {
  width: var(--vpn-content-width);
  margin: 0 auto;
  padding: 56px 0 72px;
  color: var(--vpn-ink-muted, #5b6475);
}

h1 {
  margin: 0 0 32px;
  color: var(--vpn-ink, #1f2430);
  font-size: 42px;
  line-height: 1.15;
  font-weight: 800;
}

section {
  margin: 0 0 34px;
}

h2 {
  margin: 0 0 14px;
  color: var(--vpn-ink, #1f2430);
  font-size: 26px;
  line-height: 1.25;
  font-weight: 800;
}

p {
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.75;
}

ul {
  margin: 0 0 18px 22px;
  padding: 0;
}

li {
  margin: 0 0 8px;
  font-size: 16px;
  line-height: 1.65;
}

@media (max-width: 768px) {
  .simple-page__main {
    width: 100%;
    padding: 32px 16px 48px;
    box-sizing: border-box;
  }

  h1 {
    margin-bottom: 22px;
    font-size: clamp(26px, 7vw, 34px);
  }

  h2 {
    font-size: 20px;
  }

  p,
  li {
    font-size: 15px;
  }
}
</style>
